// @ts-nocheck

import { SportsWithRaceTrackUI, SupportedLineUpSportIds } from '../../modules/line-up/constants/runtime';
import {
  selectEntitiesMatchesEntityLineupsAvailable,
  selectEntitiesMatchesEntitySportId,
  selectEntitiesMatchesEntityStartingOrdersAvailable,
} from '../../selectors/entities/matches/entitiesMatchesPrimary.selector';
import { type Selector } from '../../types/selectors';
import { createResultEqualSelector } from '../../utils/reselect';

type MatchCardOutrightPropsType = {
  areMatchLineUpsAvailable: boolean;
};

const selectMatchCardOutrightProps: Selector<MatchCardOutrightPropsType> = createResultEqualSelector(
  [
    selectEntitiesMatchesEntityLineupsAvailable,
    selectEntitiesMatchesEntitySportId,
    selectEntitiesMatchesEntityStartingOrdersAvailable,
  ],
  (isLineUpAvailable, sportId, startingOrdersAvailable) => {
    return {
      areMatchLineUpsAvailable:
        ((SportsWithRaceTrackUI.indexOf(sportId) !== -1 && startingOrdersAvailable) || isLineUpAvailable) &&
        SupportedLineUpSportIds.indexOf(sportId),
    };
  },
);

export default selectMatchCardOutrightProps;
